<script lang="ts" setup>
import MPage from ".";
</script>
<template>
  <div class="flex flex-col gap-3 medicus-grey-background">
    <m-page title="page" :buttons="[{ label: 'test' }]">
      <div class="flex justify-between">
        <div>left</div>
        <div>right</div>
      </div>
      <div>test content</div>
    </m-page>
  </div>
</template>
